import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import Constant from '@/common/constant/Constant';

export const DialogConfirmForceCreateTicket = props => {
    const { isOpen, setIsOpen, onSubmit } = props;
    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        setIsOpen(false);
    };

    const onHandlerConfirm = () => {
        onSubmit();
        setIsOpen(false);
    };

    return (
        <Dialog
            open={isOpen}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    {I18n.get(Constant.EXISTS_B2B_CUSTOMER_ERROR)}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    onClick={onHandlerConfirm}
                    className="confirm-dialog-button btn-hg32 btn-handle-delete-user-agree"
                    variant="contained"
                >
                    {I18n.get('COMBTN002')}
                </Button>
                <Button
                    className="confirm-dialog-button btn-hg32"
                    variant="contained"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {I18n.get('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
